import { createContext, useState, useEffect } from "react";

export const RouteContext = createContext();

export function RouteProvider({ children }) {
  const [route, setRoute] = useState("lpz-topo"); // default aquí

  // Persistencia opcional
  useEffect(() => {
    const saved = localStorage.getItem("selectedRoute");
    if (saved) setRoute(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedRoute", route);
  }, [route]);

  return (
    <RouteContext.Provider value={{ route, setRoute }}>
      {children}
    </RouteContext.Provider>
  );
}
